import { Bill_item } from './bill_item';
import { Competition_entry_fee } from './competition_entry_fee';
import { Entry_fee_discount } from './entry_fee_discount';
import { Payment } from './payment';
import { Authorization } from './authorization';
import { Prize_cheque } from './prize_cheque';
import { Prize_money } from './prize_money';
import { Refund } from './refund';
import { Section_entry_fee } from './section_entry_fee';
import { Tax_item } from './tax_item';
import { Transfer_in } from './transfer_in';
import { Transfer_out } from './transfer_out';

export class Statement {

	bill_items: Bill_item[] = Array();
	//bill items grouped so that each individual ledger transaction doesn't need to be listed on statement or invoice
	summary_bill_items:Bill_item[] = Array();
	requested_items: Bill_item[] = Array();
	summary_requested_items = Array();
	section_entry_fees: Section_entry_fee[] = Array();
	competition_entry_fees: Competition_entry_fee[] = Array();
	entry_fee_discounts: Entry_fee_discount[] = Array();
	payments: Payment[] = Array();
	authorizations: Authorization[] = Array();	
	refunds: Refund[] = Array();
	prize_monies: Prize_money[] = Array();
	transfers_in: Transfer_in[] = Array();
	transfers_out: Transfer_out[] = Array();
	tax_items: Tax_item[] = Array();
	
	total_bill_items: number = 0;
	total_section_entry_fees: number = 0;
	total_class_entry_fees: number = 0;
	total_entry_fee_discounts: number = 0;
	total_entry_fees: number = 0;
	total_payments: number = 0;
	total_refunds: number = 0;
	total_prize_money: number = 0;
	total_transfers_in: number = 0;
	total_transfers_out: number = 0;
	total_tax_items: number = 0;
	has_stabling_item: boolean;
	
	total_credits: number = 0;
	total_debits:number = 0;
	
	grand_total: number = 0;

	balance: number = 0;
	
	constructor(values: Object = {}) {
		Object.assign(this, values);
	}
}